import adminApiClient from '@/services/admin/api.admin';
import ADMIN_API_ENDPOINTS from '@/services/admin/endpoints.admin';
async function list(params = {}) {
    const query = new URLSearchParams();
    if (params.limit != null)
        query.set('limit', String(params.limit));
    if (params.offset != null)
        query.set('offset', String(params.offset));
    if (params.location_id != null)
        query.set('location_id', String(params.location_id));
    const url = `${ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BASE}${query.toString() ? `?${query.toString()}` : ''}`;
    return adminApiClient.get(url);
}
async function listByUser(userId, params = {}) {
    const query = new URLSearchParams();
    if (params.limit != null)
        query.set('limit', String(params.limit));
    if (params.offset != null)
        query.set('offset', String(params.offset));
    if (params.location_id != null)
        query.set('location_id', String(params.location_id));
    const url = `${ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BY_USER(userId)}${query.toString() ? `?${query.toString()}` : ''}`;
    return adminApiClient.get(url);
}
async function get(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BY_ID(id);
    return adminApiClient.get(url);
}
async function getByLocation(locationId) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BY_LOCATION(locationId);
    return adminApiClient.get(url);
}
async function create(body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BASE;
    console.log('📤 Creando política:', { url, body });
    try {
        const response = await adminApiClient.post(url, body);
        console.log('✅ Respuesta crear:', response);
        return response;
    }
    catch (error) {
        console.error('❌ Error al crear política:', error);
        console.error('Detalles:', {
            message: error?.message,
            response: error?.response,
            status: error?.response?.status,
            data: error?.response?.data
        });
        throw error;
    }
}
async function update(id, body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BY_ID(id);
    console.log('📤 Actualizando política:', { url, id, body });
    try {
        const response = await adminApiClient.put(url, body);
        console.log('✅ Respuesta actualizar:', response);
        return response;
    }
    catch (error) {
        console.error('❌ Error al actualizar política:', error);
        console.error('Detalles:', {
            message: error?.message,
            response: error?.response,
            status: error?.response?.status,
            data: error?.response?.data
        });
        throw error;
    }
}
async function updateOrCreate(locationId, body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.UPDATE_OR_CREATE(locationId);
    console.log('📤 Update or create política:', { url, locationId, body });
    try {
        const response = await adminApiClient.post(url, body);
        console.log('✅ Respuesta update-or-create:', response);
        return response;
    }
    catch (error) {
        console.error('❌ Error al update-or-create política:', error);
        console.error('Detalles:', {
            message: error?.message,
            response: error?.response,
            status: error?.response?.status,
            data: error?.response?.data
        });
        throw error;
    }
}
async function remove(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_POLICIES.BY_ID(id);
    console.log('📤 Eliminando política:', { url, id });
    try {
        const response = await adminApiClient.delete(url);
        console.log('✅ Respuesta eliminar:', response);
        return response;
    }
    catch (error) {
        console.error('❌ Error al eliminar política:', error);
        console.error('Detalles:', {
            message: error?.message,
            response: error?.response,
            status: error?.response?.status,
            data: error?.response?.data
        });
        throw error;
    }
}
export const adminLocationPoliciesService = {
    list,
    listByUser,
    get,
    getByLocation,
    create,
    update,
    updateOrCreate,
    remove
};
export default adminLocationPoliciesService;
